import { render, staticRenderFns } from "./TariffDiscount.vue?vue&type=template&id=e7772850&scoped=true"
import script from "./TariffDiscount.vue?vue&type=script&lang=js"
export * from "./TariffDiscount.vue?vue&type=script&lang=js"
import style0 from "./TariffDiscount.vue?vue&type=style&index=0&id=e7772850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7772850",
  null
  
)

export default component.exports